import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function Biz() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-32 pb-10 sm:pb-20 px-4 sm:px-6">
        <div className="absolute inset-0 bg-gradient-to-b from-red-500/10 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-block bg-gradient-to-r from-red-500 to-red-600 text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6 whitespace-nowrap">
              사업자용
            </div>
            <h1 className="text-[36px] sm:text-[60px] md:text-[80px] font-bold text-white mb-4 sm:mb-6">
              LEXO <span className="bg-gradient-to-r from-red-400 to-red-500 bg-clip-text text-transparent">Biz</span>
            </h1>
            <p className="text-sm sm:text-xl text-gray-300 max-w-3xl mx-auto mb-6 sm:mb-12 px-2">
              일본 사업 진출을 위한 전문 일본어 학습
              <br />
              사업가에게 필요한 실무 표현을 마스터하세요
            </p>
            <div className="inline-flex items-center gap-3 bg-red-500/10 border border-red-500/30 rounded-xl px-6 sm:px-10 py-3 sm:py-4">
              <i className="ri-mail-line text-red-400 text-lg sm:text-2xl w-5 h-5 sm:w-7 sm:h-7 flex items-center justify-center"></i>
              <div className="text-left">
                <p className="text-gray-400 text-xs sm:text-sm">요금 및 플랜 문의</p>
                <a href="mailto:lexojp.help@gmail.com" className="text-red-400 font-semibold text-sm sm:text-lg hover:text-red-300 transition-colors whitespace-nowrap">
                  lexojp.help@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-10 sm:py-20 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl sm:text-4xl font-bold text-white text-center mb-8 sm:mb-16">
            Biz 플랜의 핵심 혜택
          </h2>
          <div className="grid grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-8">
            {[
              {
                icon: 'ri-file-pdf-line',
                title: '사업자 실무 표현 PDF',
                description: '비즈니스 미팅, 협상, 계약 등 실무에서 바로 사용할 수 있는 표현 제공'
              },
              {
                icon: 'ri-volume-up-line',
                title: '원어민 음성 파일',
                description: '원어민이 직접 녹음한 음성 파일로 정확한 발음과 억양을 학습'
              },
              {
                icon: 'ri-mic-line',
                title: '원어민 녹음 첨삭',
                description: '본인의 녹음을 원어민이 직접 첨삭하여 발음과 표현을 교정'
              },
              {
                icon: 'ri-briefcase-line',
                title: '비즈니스 매너',
                description: '일본 비즈니스 문화와 에티켓을 이해하고 신뢰를 쌓으세요'
              },
              {
                icon: 'ri-mail-line',
                title: '이메일 & 문서 작성',
                description: '비즈니스 이메일, 제안서, 계약서 등 문서 작성법 학습'
              }
            ].map((feature, index) => (
              <div key={index} className="bg-gradient-to-br from-red-500/10 to-red-600/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-8 hover:from-red-500/20 hover:to-red-600/20 transition-all duration-300 border border-red-500/20">
                <div className="w-8 h-8 sm:w-14 sm:h-14 bg-gradient-to-br from-red-500 to-red-600 rounded-lg sm:rounded-xl flex items-center justify-center mb-2 sm:mb-6 mx-auto sm:mx-0">
                  <i className={`${feature.icon} text-white text-sm sm:text-2xl w-4 h-4 sm:w-6 sm:h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-[11px] sm:text-xl font-bold text-white mb-1 sm:mb-3 text-center sm:text-left">{feature.title}</h3>
                <p className="text-gray-400 text-[9px] sm:text-base hidden sm:block">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learning Content Section */}
      <section className="py-10 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-transparent to-red-500/5">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-4xl font-bold text-white text-center mb-8 sm:mb-16">
            이런 내용을 배워요
          </h2>
          <div className="grid grid-cols-2 gap-2 sm:gap-8">
            {[
              {
                title: '비즈니스 미팅',
                examples: ['자기소개 & 회사 소개', '제안 및 협상하기', '의견 조율하기', '미팅 마무리 인사']
              },
              {
                title: '거래처 소통',
                examples: ['전화 응대하기', '이메일 작성하기', '일정 조율하기', '감사 인사 전하기']
              },
              {
                title: '프레젠테이션',
                examples: ['발표 시작하기', '데이터 설명하기', '질의응답 대응', '마무리 멘트']
              },
              {
                title: '계약 & 협상',
                examples: ['조건 제시하기', '가격 협상하기', '계약 조건 확인', '합의 도출하기']
              }
            ].map((category, index) => (
              <div key={index} className="bg-gradient-to-br from-red-500/10 to-red-600/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-8 border border-red-500/20">
                <h3 className="text-sm sm:text-2xl font-bold text-white mb-2 sm:mb-6">{category.title}</h3>
                <ul className="space-y-1 sm:space-y-3">
                  {category.examples.map((example, idx) => (
                    <li key={idx} className="flex items-center text-gray-300">
                      <i className="ri-check-line text-red-400 text-xs sm:text-xl mr-1 sm:mr-3 flex-shrink-0 w-3 h-3 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                      <span className="text-[10px] sm:text-base">{example}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-10 sm:py-20 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl sm:text-4xl font-bold text-white text-center mb-8 sm:mb-16">
            Biz 회원들의 이야기
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8">
            {[
              {
                name: '박**',
                role: '사업가',
                content: '일본에서 대학교 다니고 상사에서 10년 넘게 일했는데, 독립해서 사업을 시작하면서 사업가용 일본어가 필요했어요. LEXO Biz가 정말 많이 도움됐습니다!'
              },
              {
                name: '김**',
                role: 'CEO',
                content: '원어민 녹음 첨삭이 정말 좋아요. 제 발음의 문제점을 정확히 짚어주셔서 일본 거래처와의 미팅에서 자신감이 생겼습니다.'
              },
              {
                name: '최**',
                role: '무역업',
                content: '실무 표현 PDF가 실제 비즈니스 상황에서 바로 사용할 수 있어서 좋아요. 일본 바이어와의 협상이 훨씬 수월해졌습니다.'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-red-500/10 to-red-600/10 backdrop-blur-sm rounded-xl sm:rounded-xl p-5 sm:p-8 border border-red-500/20">
                <div className="flex items-center mb-4 sm:mb-6">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold mr-3 sm:mr-4 text-sm sm:text-base">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="text-white font-bold text-sm sm:text-base">{testimonial.name}</div>
                    <div className="text-gray-400 text-xs sm:text-sm">{testimonial.role}</div>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed text-sm sm:text-base">{testimonial.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10 sm:py-20 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-red-500/20 to-red-600/20 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-12 border border-red-500/30">
            <h2 className="text-xl sm:text-4xl font-bold text-white mb-3 sm:mb-6">
              일본 비즈니스의 문을 여세요
            </h2>
            <p className="text-sm sm:text-xl text-gray-300 mb-6 sm:mb-10">
              사업가를 위한 전문 일본어 학습 프로그램<br />
              <span className="text-gray-400 text-xs sm:text-base">요금 및 플랜은 이메일로 문의해 주세요</span>
            </p>
            <a
              href="mailto:lexojp.help@gmail.com"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold px-8 sm:px-12 py-3 sm:py-4 rounded-xl text-sm sm:text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center"></i>
              이메일로 문의하기
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 sm:py-20 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-4xl font-bold text-white text-center mb-10 sm:mb-16">
            자주 묻는 질문
          </h2>
          <div className="space-y-3 sm:space-y-6">
            {[
              {
                q: 'Biz 플랜은 어떤 분들에게 적합한가요?',
                a: '일본 사업 진출을 준비하시거나, 일본 거래처와 소통이 필요한 사업가, CEO, 무역업 종사자분들께 적합합니다.'
              },
              {
                q: '원어민 녹음 첨삭은 어떻게 진행되나요?',
                a: '본인의 발음을 녹음하여 제출하시면, 원어민이 직접 듣고 발음, 억양, 표현의 문제점을 상세히 첨삭해드립니다.'
              },
              {
                q: '환불 정책은 어떻게 되나요?',
                a: '결제 후 7일 이내 콘텐츠 미사용 시 환불 가능합니다. 단, 부가세 및 카드 수수료는 환불되지 않습니다. 콘텐츠를 이용한 경우에는 환불이 불가합니다.'
              },
              {
                q: '기타 문의는 어떻게 하나요?',
                a: '모든 문의 사항은 lexojp.help@gmail.com 으로 연락주시면 신속하게 답변드리겠습니다.'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm rounded-lg sm:rounded-xl p-4 sm:p-6 hover:bg-white/10 transition-all duration-300">
                <h3 className="text-sm sm:text-lg font-bold text-white mb-2 sm:mb-3">{faq.q}</h3>
                <p className="text-gray-400 text-xs sm:text-base">{faq.a}</p>
              </div>
            ))}
          </div>
          
          {/* 문의 및 환불 카드 - FAQ 아래로 이동 */}
          <div className="mt-8 sm:mt-12 bg-gradient-to-br from-red-500/10 to-red-600/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-5 sm:p-8 text-center border border-red-500/20">
            <div className="w-10 h-10 sm:w-14 sm:h-14 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <i className="ri-mail-send-line text-red-400 text-lg sm:text-2xl"></i>
            </div>
            <h3 className="text-base sm:text-xl font-bold text-white mb-2 sm:mb-3">문의 및 환불</h3>
            <p className="text-gray-400 text-xs sm:text-base mb-3 sm:mb-4">
              문의 사항이나 환불이 필요하신 경우 아래 이메일로 연락해주세요
            </p>
            <a href="mailto:lexojp.help@gmail.com" className="text-red-400 font-semibold text-base sm:text-lg hover:text-red-300 transition-colors">
              lexojp.help@gmail.com
            </a>
            <p className="text-gray-500 text-[10px] sm:text-sm mt-2 sm:mt-3">
              * 환불 시 부가세 및 카드 수수료는 환불되지 않습니다
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
